// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-main {
  width: 90%;
  margin: 2.5rem auto;
  padding: 1.875rem 0;
}
.user-main .searchbar {
  border-radius: 0.313rem;
}
.user-main .filter {
  margin: 1.25rem 0 0 0;
}
.user-main h4 {
  text-align: center;
}
.user-main .Buttons {
  margin: 3.125rem 0 1.875rem auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.user-main .campaign-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
  margin: 0 0.313rem;
  margin-bottom: 1.25rem;
}
.user-main .campaign-btn svg {
  margin-right: 0.625rem;
  font-size: 1.25rem;
}
.clear-btn {
  padding: 0 1.25rem;
  /* height: 20.313rem; */
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.063rem;
}
.user-main .filter .more-button {
  border-radius: 0.313rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: -moz-fit-content;
  width: fit-content;
}
.top-stats {
  border-radius: 0.75rem;
  /* margin: 2.5rem 0; */
}
.stats {
  /* box-shadow: var(--boxShadow); */
  padding: 1.25rem;
  border-radius: 0.25rem;
  /* background-color: var(--secondary-color); */
  /* background-color: white; */
  background-color: #f7f7f7;
  min-height: 6.25rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border-radius: 0.75rem;
  padding-bottom: 0.5rem;
}
.stats h5 {
  /* color: white; */
  /* color: var(--secondary-color); */
  color: black;
  margin-bottom: 0;
  font-size: 1rem;
}

.stats span {
  /* color: white; */
  /* color: black; */
  color: #778899 !important;
  /* color: var(--secondary-color); */
  font-size: 1.125rem;
  font-weight: bold;
  letter-spacing: 0.063rem;
}

.stats .view-div {
  display: flex;
  justify-content: flex-end;
  min-height: 35px;
}
.stats .view-div p {
  color: #778899 !important;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0.063rem;
  /* text-decoration: underline; */
}
.stats .view-div p:hover {
  text-decoration: underline;
}

.user-main .more-filter {
  display: flex;
  justify-content: flex-end;
}
.user-main .filter .more-button svg {
  margin-right: 0.625rem;
}
.ant-drawer-body .ant-select,
.ant-drawer-body .ant-input {
  margin: 0.625rem 0 1.25rem 0;
}
.ant-drawer-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.ant-drawer-body button {
  display: flex;
  margin-left: auto;
}
.user-main .graphs {
  margin: 1.875rem 0;
}

.user-main .ant-table tr td:hover {
  cursor: pointer;
}

.user-main .ant-row {
  margin: 1.875rem 0;
  /* padding: 0 0.313rem; */
}

@media (max-width: 43.125rem) {
  .user-main .searchbar {
    width: 100%;
  }
  .user-main .filter {
    flex-direction: column;
    align-items: flex-end;
    margin-bottom: 1.25rem;
  }
  .ant-drawer-content-wrapper {
    width: 70% !important;
  }
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list {
  justify-content: space-evenly !important;
  border-radius: 1rem !important;
  background-color: var(--white) !important;
  width: 100% !important;
  transition: none !important;
  transform: none !important;
}

@media (max-width: 53.125rem) {
  .top-stats {
    flex-direction: column;
    align-items: flex-start;
  }
  .box {
    flex-direction: column;
    margin: 0.625rem 0;
  }
  .stats {
    margin: 0.625rem 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/home.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;EACtB,8CAA8C;EAC9C,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;;EAEE,wCAAwC;EACxC,8BAA8B;EAC9B,yCAAyC;EACzC,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".user-main {\n  width: 90%;\n  margin: 2.5rem auto;\n  padding: 1.875rem 0;\n}\n.user-main .searchbar {\n  border-radius: 0.313rem;\n}\n.user-main .filter {\n  margin: 1.25rem 0 0 0;\n}\n.user-main h4 {\n  text-align: center;\n}\n.user-main .Buttons {\n  margin: 3.125rem 0 1.875rem auto;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n.user-main .campaign-btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 2.5rem;\n  margin: 0 0.313rem;\n  margin-bottom: 1.25rem;\n}\n.user-main .campaign-btn svg {\n  margin-right: 0.625rem;\n  font-size: 1.25rem;\n}\n.clear-btn {\n  padding: 0 1.25rem;\n  /* height: 20.313rem; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  letter-spacing: 0.063rem;\n}\n.user-main .filter .more-button {\n  border-radius: 0.313rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: fit-content;\n}\n.top-stats {\n  border-radius: 0.75rem;\n  /* margin: 2.5rem 0; */\n}\n.stats {\n  /* box-shadow: var(--boxShadow); */\n  padding: 1.25rem;\n  border-radius: 0.25rem;\n  /* background-color: var(--secondary-color); */\n  /* background-color: white; */\n  background-color: #f7f7f7;\n  min-height: 6.25rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  border-radius: 0.75rem;\n  padding-bottom: 0.5rem;\n}\n.stats h5 {\n  /* color: white; */\n  /* color: var(--secondary-color); */\n  color: black;\n  margin-bottom: 0;\n  font-size: 1rem;\n}\n\n.stats span {\n  /* color: white; */\n  /* color: black; */\n  color: #778899 !important;\n  /* color: var(--secondary-color); */\n  font-size: 1.125rem;\n  font-weight: bold;\n  letter-spacing: 0.063rem;\n}\n\n.stats .view-div {\n  display: flex;\n  justify-content: flex-end;\n  min-height: 35px;\n}\n.stats .view-div p {\n  color: #778899 !important;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: bold;\n  letter-spacing: 0.063rem;\n  /* text-decoration: underline; */\n}\n.stats .view-div p:hover {\n  text-decoration: underline;\n}\n\n.user-main .more-filter {\n  display: flex;\n  justify-content: flex-end;\n}\n.user-main .filter .more-button svg {\n  margin-right: 0.625rem;\n}\n.ant-drawer-body .ant-select,\n.ant-drawer-body .ant-input {\n  margin: 0.625rem 0 1.25rem 0;\n}\n.ant-drawer-body {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.ant-drawer-body button {\n  display: flex;\n  margin-left: auto;\n}\n.user-main .graphs {\n  margin: 1.875rem 0;\n}\n\n.user-main .ant-table tr td:hover {\n  cursor: pointer;\n}\n\n.user-main .ant-row {\n  margin: 1.875rem 0;\n  /* padding: 0 0.313rem; */\n}\n\n@media (max-width: 43.125rem) {\n  .user-main .searchbar {\n    width: 100%;\n  }\n  .user-main .filter {\n    flex-direction: column;\n    align-items: flex-end;\n    margin-bottom: 1.25rem;\n  }\n  .ant-drawer-content-wrapper {\n    width: 70% !important;\n  }\n}\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list {\n  justify-content: space-evenly !important;\n  border-radius: 1rem !important;\n  background-color: var(--white) !important;\n  width: 100% !important;\n  transition: none !important;\n  transform: none !important;\n}\n\n@media (max-width: 53.125rem) {\n  .top-stats {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .box {\n    flex-direction: column;\n    margin: 0.625rem 0;\n  }\n  .stats {\n    margin: 0.625rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
